import { FC } from 'react';

import {
  BattleNetIcon,
  EAIcon,
  EGSIcon,
  ICommonIconProps,
  ISelectOption,
  SteamIcon,
} from '@smartshell/ui-kit';

import { ELauncher } from 'types';

export const LAUNCHERS: Array<ISelectOption<ELauncher>> = [
  { value: ELauncher.STEAM, title: 'Steam' },
  {
    value: ELauncher.EGS,
    title: 'Epic Games Launcher',
  },
  {
    value: ELauncher.BATTLE_NET,
    title: 'Battle.net',
  },
  {
    value: ELauncher.EA,
    title: 'EA Play',
  },
];

export const ICONS: Record<ELauncher, FC<ICommonIconProps>> = {
  [ELauncher.STEAM]: SteamIcon,
  [ELauncher.EGS]: EGSIcon,
  [ELauncher.BATTLE_NET]: BattleNetIcon,
  [ELauncher.EA]: EAIcon,
};

export const ICON_PROPS: ICommonIconProps = {
  size: 'm',
};
